/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.controllers').controller('FlexyBeautyCtrl', [
    "$scope", "$dialog", "$window", "$location", "$sce", "SubscriptionView", "UserSrv", "DateSrv", "SubscriptionSrv", "CompanyView", "CompanyData",
    "StoreAppData", "StoreAppView", "$filter", "CompanySrv", "App", "AppSrv", "AppData", "AppAttribute", "GlobalVariable", "HumanResourceData",
    "HumanResourceView", "CurrencyManager", "gettextCatalog", "LanguageManager", "NumberSeparatorType", "Countries", "StoreAppCode", "LoaderKyc",
    "KycDocumentData", "KycDocumentStatus", "KycRefusedReason", "KycDocumentType", "Auth", "LegalType", "UboStatementSrv", "UboStatementData",
    "UboStatementView", "UboView", "UboStatus", "DateFormator", "KycSpecifications", "KycStatusConstants", "KycStatusSrv", "AppCode",
    "StoreAppCodeFactory", "SmsReminderSettingsSrv", "SmsReminderSettings", "Constants", "BillingManagerSrv", "PaymentServiceSrv",
    function ($scope, $dialog, $window, $location, $sce, SubscriptionView, UserSrv, DateSrv, SubscriptionSrv, CompanyView, CompanyData,
              StoreAppData, StoreAppView, $filter, CompanySrv, App, AppSrv, AppData, AppAttribute, GlobalVariable, HumanResourceData,
              HumanResourceView, CurrencyManager, gettextCatalog, LanguageManager, NumberSeparatorType, Countries, StoreAppCode, LoaderKyc,
              KycDocumentData, KycDocumentStatus, KycRefusedReason, KycDocumentType, Auth, LegalType, UboStatementSrv, UboStatementData,
              UboStatementView, UboView, UboStatus, DateFormator, KycSpecifications, KycStatusConstants, KycStatusSrv, AppCode,
              StoreAppCodeFactory, SmsReminderSettingsSrv, SmsReminderSettings, Constants, BillingManagerSrv, PaymentServiceSrv) {

        mangoPay.cardRegistration.clientId = "flexybeauty";
        this.link = "";

        $scope.dd = {
            kycDocumentsConst: {
                MAX_FILE_SIZE: 7 * 1024 * 1024,
                LEGAL_TYPE: LegalType,
                EXTENSIONS: ['pdf', 'png', 'jpg', 'jpeg']
            },
            kycStatusConstants: KycStatusConstants,
            view: {
                icalUrl: "",
                legalType: null,
                kycDocumentsType: KycDocumentType,
                kycStatus: null,
                kycDocuments: [],
                humanResourcesView: [],
                kycDocumentStatus: KycDocumentStatus,
                uboStatus: UboStatus,
                kycRefusedReason: KycRefusedReason,
                numberOfUploadedDocuments: KycDocumentData.kycDocuments.length,
                storeAppsView: [],
                companyView: null,
                displaySubConf: 1,
                cStorePanel: 2,
                cAppStorePanel: 1,
                flexyStoreHelp: false,
                hasSmsReminder: false,
                cSubscriptionView: null,
                displayErrors: false,
                link: "",
                subTotalHT: 0,
                totalHT: 0,
                nbDaysTrial: -1,
                smsReminderSettings: null,
                hoursToSend: [],
                isLoadingSmsReminderSettings: false,
                subscriptions: {
                    base: {
                        filterPricePayed: true,
                        filterPriceFree: true,
                        filterCoupon: true,
                        filterOperationnal: true,
                        filterBeta: false,
                        filterFuture: false
                    },
                    baseList: [],
                    sub: {
                        annual: null
                    },
                    subList: [],
                    configList: [],
                    activeRecurringList: [],
                    activeNoRecurringList: [],
                    activeCouponList: []
                },
                invoice: {
                    loading: false,
                    errorMessage: null,
                    currentAnnualInvoiceView: null,
                    billingManager: {
                        loading: false,
                        creatingPortalSession: false,
                        errorWithPortalSession: false,
                        instanceInitialized: false,
                    }
                },
                card: {
                    loading: false,
                    cardRegistrationLoaded: false,
                    data: {
                        cardNumber: "",
                        cardExpirationDateMonth: "00",
                        cardExpirationDateYear: "00",
                        cardCvx: "",
                        cardType: "CB_VISA_MASTERCARD"
                    },
                    datePickerOpened: false,
                    dateOptions: {
                        startingDay: 1,
                        showWeeks: false,
                        datepickerMode: 'year',
                        yearRange: 20
                    },
                    displayErrorMessage: false,
                    registerSuccess: false
                },
                errors: {
                    alertMessage: "",
                    EXTENSION_ERROR_MESSAGE: gettextCatalog.getString("Impossible d'importer le fichier sélectionné. Le fichier doit être au format .png / .jpg / .jpeg / .pdf"),
                    MAX_FILE_SIZE_ERROR_MESSAGE: gettextCatalog.getString("Le fichier est trop volumineux. La taille du fichier ne doit pas dépasser 7MB"),
                    OTHER_KYC_ERROR_MESSAGE: gettextCatalog.getString("Impossible d'importer le fichier sélectionné")
                },
                uploadedDocuments: {
                    identityProof: false,
                    registrationProof: false,
                    shareholdersDeclaration: false,
                    articleOfAssociation: false
                },
                flowConfig: {
                    kycDocumentType: null,
                    target: null,
                    headers: {Authorization: null},
                    testChunks: false
                },

                onlinePayment: {
                    tab: 1,
                    editedUboView: null,
                    uboStatementsView: [],
                    editedUboStatementView: new UboStatementView(),
                    uboStatementSubmitted: false,
                    uboStatementErrorMsg: null,
                    currentUboStatus: null,
                    uboLoading: false,
                    isUboForm: false,
                    isValidKycDocuments: false,
                    certification: {
                        s1: true,
                        s2: true,
                        s3: true
                    },
                    payOutAmount: 0,
                    payOutAmountInput: "0",
                    payOutSuccessMessage: false,
                    onPayOutAmountInputChange: function () {
                        if (this.payOutAmountInput != null && typeof this.payOutAmountInput === 'string') {
                            var priceStr = CurrencyManager.getPriceFromPriceInput(this.payOutAmountInput);
                            var price = parseFloat(priceStr);
                            if (price !== "NaN")
                                this.payOutAmount = price;
                            else
                                this.payOutAmount = null;
                        }
                    },
                    updatePayOutAmountInputArrow: function (number) {
                        if (this.payOutAmountInput != null && typeof this.payOutAmountInput === 'string') {
                            var priceStr = CurrencyManager.getPriceFromPriceInput(this.payOutAmountInput);
                            var price = parseFloat(priceStr);
                            if (price !== "NaN")
                                if ((price + number) <= $scope.dd.view.wallet.walletAmount)
                                    price += number;
                                else
                                    price = $scope.dd.view.wallet.walletAmount;

                            this.payOutAmountInput = $filter('currencyFormatFilter')(price);
                            this.payOutAmount = price;
                        }
                    }
                },
                bankAccount: {
                    ownerName: "",
                    ownerAddressLine1: "",
                    ownerPostalCode: "",
                    ownerCity: "",
                    ownerCountry: "FR",
                    bankAccountDetails: {
                        iban: "",
                        bic: "",
                        accountNumber: "",
                        sortCode: ""
                    },
                    loading: false,
                    errorMessage: null,
                    redirectURL: null
                },
                bankAccountTypes: {
                    iban: "IBAN",
                    gb: "GB",
                    us: "US",
                },
                wallet: {
                    loaded: false,
                    walletAmount: 0,
                    payInsPage: 1,
                    currency: 'EUR',
                    payIns: [],
                    payOuts: []
                },
                uibDate: {
                    birthdate: null,
                    format: `dd/MM/yyyy`,
                    dateOptions: {
                        maxDate: new Date()
                    },
                    opened: false,
                    defaultBirthdayYear: DateSrv.DEFAULT_BIRTHDAY_YEAR
                }
            },
            CONSTANTS: {
                STORE_APP_CODE: StoreAppCode,
                COUNTRIES: Countries
            },
            specifications: {
                isKycSelfCertificated: false,
                isSelfContractor: false,
                isKycCertificated: false
            }
        };

        $scope.checkValidAllKycDocuments = function () {
            let identity = false;
            let registration = false;
            let articlesOfAssociation = false;

            $scope.dd.view.kycDocuments.forEach((kyc) => {
                switch (kyc.type) {
                    case $scope.dd.view.kycDocumentsType.IDENTITY_PROOF.id:
                        identity = kyc.status === KycDocumentStatus.VALIDATED.id;
                        break;
                    case $scope.dd.view.kycDocumentsType.REGISTRATION_PROOF.id:
                        registration = kyc.status === KycDocumentStatus.VALIDATED.id;
                        break;
                    case $scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id:
                        articlesOfAssociation = kyc.status === KycDocumentStatus.VALIDATED.id;
                        break;
                }
            });

            $scope.dd.view.onlinePayment.isValidKycDocuments = identity && registration && articlesOfAssociation;
        };

        $scope.getKycStatus = function () {
            KycStatusSrv.getKycStatus().then(
                res => {
                    $scope.dd.view.kycStatus = $scope.dd.kycStatusConstants.getStatusByKey(res.status);
                    let kycCertification = new KycSpecifications.KycCertification();
                    $scope.dd.specifications.isKycCertificated = kycCertification.isSatisfiedBy($scope.dd.view.kycStatus.key);
                },
                () => {
                    $scope.dd.view.kycStatus = null;
                    $scope.dd.specifications.isKycCertificated = false;
                }
            );
        };

        $scope.onTabCertify = function (currentStep) {
            $scope.dd.view.onlinePayment.certification[`s${currentStep}`] = true;

            if (currentStep === 2) {
                if ($scope.dd.view.numberOfUploadedDocuments >= $scope.getKycDocumentsNumber()) {
                    $scope.dd.view.onlinePayment.certification.s3 = true;
                }
            }
        };

        $scope.resetUboForm = function (form) {
            $scope.dd.view.onlinePayment.editedUboView = new UboView();

            if (form) {
                form.$setPristine();
                form.$setUntouched();
            }
        };

        $scope.hideUboForm = function (form) {
            $scope.dd.view.onlinePayment.isUboForm = false;
            $scope.resetUboForm(form);
        };

        $scope.showUboForm = function (uboView) {
            if (uboView) {
                $scope.dd.view.onlinePayment.editedUboView = uboView;
                if (uboView.birth.day) {
                    $scope.dd.view.uibDate.birthdate = DateFormator.dayIdToDate(uboView.birth.day);
                }
            } else {
                $scope.resetUboForm();
                $scope.dd.view.uibDate.birthdate = null;
            }

            $scope.dd.view.onlinePayment.isUboForm = true;
        };

        $scope.onDeleteEditedUbo = function (localId) {
            let newUbosView = $scope.dd.view.onlinePayment.editedUboStatementView.ubosView.filter(uboView => uboView.localId !== localId);
            $scope.dd.view.onlinePayment.editedUboStatementView.ubosView = newUbosView;
            $scope.hideUboForm();
        };

        $scope.closeCalendar = function () {
            $scope.dd.view.uibDate.opened = false;
        };

        $scope.openCalendar = function () {
            if (!$scope.dd.view.uibDate.birthdate) {
                let initDate = new Date($scope.dd.view.uibDate.defaultBirthdayYear, 0, 1);
                $scope.dd.view.uibDate.birthdate = initDate;
            }
            $scope.dd.view.uibDate.opened = true;
        };

        $scope.onSubmitUboForm = function (form) {
            $scope.dd.view.onlinePayment.editedUboView.birth.day = DateFormator.dateToDayId($scope.dd.view.uibDate.birthdate);

            if (!$scope.dd.view.onlinePayment.editedUboView.localId && !$scope.dd.view.onlinePayment.editedUboView.id) {
                $scope.dd.view.onlinePayment.editedUboView.localId = Date.now();
                $scope.dd.view.onlinePayment.editedUboStatementView.ubosView.push($scope.dd.view.onlinePayment.editedUboView);
            } else { /* update existing ubo */
                let ubosView = $scope.dd.view.onlinePayment.editedUboStatementView.ubosView.map(uboView => {
                    if (uboView.localId === $scope.dd.view.onlinePayment.editedUboView.localId) {
                        uboView = $scope.dd.view.onlinePayment.editedUboView;
                    }
                    return uboView;
                });
                $scope.dd.view.onlinePayment.editedUboStatementView.ubosView = ubosView;
            }

            $scope.hideUboForm(form);
            $scope.openUboFormConfirmDialog();
        };

        $scope.openUboFormConfirmDialog = function () {
            const opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                dialogClass: "modal modal-sm",
                templateUrl: "/partials/flexyBeauty/dialog/uboFormConfirm.html",
                controller: "DialogCtrl",
                resolve: {
                    dialogsModel: function () {
                        let tableModel = {
                            ubosView: $scope.dd.view.onlinePayment.editedUboStatementView.ubosView
                        };
                        return tableModel;
                    }
                }
            };

            const d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    if (result.add) {
                        $scope.showUboForm(null);
                    } else if (result.send) {
                        $scope.saveUboStatement();
                    }
                }
            });
        };

        $scope.onInitCertification = function () {
            if (KycDocumentData.kycDocuments.length === 0) {
                $scope.dd.view.onlinePayment.certification.s1 = false;
                $scope.dd.view.onlinePayment.certification.s2 = false;
                $scope.dd.view.onlinePayment.certification.s3 = false;
            }

            $scope.getUboStatement();
        };

        $scope.getUboStatement = function () {
            $scope.dd.view.onlinePayment.uboLoading = true;
            UboStatementSrv.query().then(() => {
                let uboStatements = UboStatementData.getUboStatements();
                if (uboStatements.length !== 0) {
                    let nbUboStatements = uboStatements.length;
                    $scope.dd.view.onlinePayment.currentUboStatus = uboStatements[nbUboStatements - 1].status;
                    for (let i = 0; i < nbUboStatements; i++) {
                        let uboStatementView = new UboStatementView(uboStatements[i]);

                        if (uboStatementView.status === $scope.dd.view.uboStatus.INCOMPLETE.id) {
                            $scope.dd.view.onlinePayment.editedUboStatementView = uboStatementView;
                        } else {
                            $scope.dd.view.onlinePayment.uboStatementsView.push(uboStatementView);
                        }
                    }
                }

                $scope.dd.view.onlinePayment.uboLoading = false;
            }).catch(() => $scope.dd.view.onlinePayment.uboLoading = false);
        };

        $scope.saveUboStatement = function () {
            if (!$scope.dd.view.onlinePayment.uboStatementSubmitted) {
                $scope.dd.view.onlinePayment.uboStatementSubmitted = true;
                $scope.dd.view.onlinePayment.uboStatementErrorMsg = null;
                $scope.dd.view.onlinePayment.editedUboStatementView.updateModel().then(
                    () => {
                        $scope.dd.view.onlinePayment.uboStatementSubmitted = false;
                        $scope.getUboStatement();
                        $scope.getKycStatus();
                    },
                    (err) => {
                        $scope.dd.view.onlinePayment.uboStatementSubmitted = false;

                        if (err && err.data) {
                            $scope.dd.view.onlinePayment.uboStatementErrorMsg = err.data.message;
                        }
                    }
                );
            }
        };

        //Mock for Oui/Non toggle buttons
        $scope.isEnglishLanguage = function () {
            return LanguageManager.isEnglishLanguage();
        };

        $scope.isFrenchLanguage = function () {
            return LanguageManager.isFrenchLanguage();
        };

        $scope.getStoreAppsView = function () {
            return $scope.dd.view.storeAppsView;
        };

        $scope.getStoreAppView = function (storeApp) {
            for (var i = 0; i < $scope.dd.view.storeAppsView.length; i++) {
                if ($scope.dd.view.storeAppsView[i].getModel() === storeApp) {
                    return $scope.dd.view.storeAppsView[i];
                }
            }
            return null;
        };

        $scope.$watch('ad.sDm', function (newValue, oldValue) {
            if (newValue === "invoice") {
                $scope.loadBillingManagerIfNeeded();
            }
        });

        $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
            if (newValue) {
                if ($scope.ad.loggedUser.company && $scope.ad.loggedUser.company.companyLegal != null) {
                    $scope.initializeOnLoading();
                } else {
                    $scope.dd.view.paymentUserIsLoading = true;
                    UserSrv.loadLoggedUserPayment($scope.ad.loggedUser,
                        function (data) {
                            $scope.dd.view.paymentUserIsLoading = false;
                            $scope.initializeOnLoading();
                        }, function () {
                            $scope.dd.view.paymentUserIsLoading = false;
                        }
                    );
                }
            }
        });

        $scope.initializeOnLoading = function () {
            if ($scope.ad.loggedUser.company.companyLegal) {
                $scope.ad.view.companyView.loadCompanyLegalFrom($scope.ad.loggedUser.company.companyLegal);
                $scope.ad.view.companyView.updateCompanyLegalModel();
            }
            const kycSelfCertification = new KycSpecifications.KycSelfCertification();
            $scope.dd.specifications.isKycSelfCertificated = kycSelfCertification.isSatisfiedBy();

            if ($scope.ad.loggedUser && $scope.ad.loggedUser.company) {
                if (!$scope.ad.managerMode) {
                    if ($scope.ad.sDm === "flexyStore" && $scope.ad.ssDomain) {
                        $scope.toggleManagerMode(this);
                    }
                }

                $scope.initializeIcalDatas();

                $scope.dd.view.storeAppsView = [];
                let storeApps = StoreAppData.getActiveList();
                for (let i = 0; i < storeApps.length; i++) {
                    $scope.dd.view.storeAppsView.push(new StoreAppView(storeApps[i], StoreAppData.getIndexOf(storeApps[i]), $scope));
                }
                $scope.dd.view.storeAppsView = $filter('orderBy')($scope.dd.view.storeAppsView, 'order');//TODO OPTIMIZE
                $scope.dd.view.companyView = new CompanyView($scope.ad.loggedUser.company, CompanyData.getIndexOf($scope.ad.loggedUser.company), $scope);
                $scope.dd.view.companyView.updateSubscriptions();

                if ($scope.ad.loggedUser.isLoggedToProduction()) {
                    mangoPay.cardRegistration.baseURL = "https://api.mangopay.com";
                }

                $scope.getWalletData();

                if ($scope.ad.sDm === "flexyStore" && $scope.ad.ssDomain) {
                    $scope.onFlexyStoreOption($scope.ad.ssDomain);
                }

                $scope.dd.view.invoice.currentAnnualInvoiceView = $scope.dd.view.companyView.getLastInvoiceView("annualSubscription", "payed");

                const selfContractor = new KycSpecifications.SelfContractor();
                $scope.dd.specifications.isSelfContractor = selfContractor.isSatisfiedBy($scope.ad.loggedUser);
            }
        }

        $scope.initializeIcalDatas = function () {
            let humanResources = HumanResourceData.getActiveList();
            let hrView;

            for (let i = 0; i < humanResources.length; i++) {
                hrView = new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), $scope, humanResources[i].order);
                $scope.dd.view.humanResourcesView.push(hrView);
            }

            $scope.dd.view.icalUrl = $location.protocol() + "://" + $location.host();
            if ($location.port() != '' && $location.port() != "443")
                $scope.dd.view.icalUrl += ":" + $location.port();
            $scope.dd.view.icalUrl += "/ical/" + $scope.ad.companyCode + "/";
        };

        $scope.onFlexyStoreOption = function (storeViewCode) {
            if ($scope.dd.view.companyView) {
                let subscriptionsView = $scope.dd.view.companyView.subscriptionsView;
                if (subscriptionsView) {
                    const selectedView = subscriptionsView.find((view) => view.storeAppView.code === storeViewCode);
                    if (selectedView !== undefined) {
                        $scope.onConfigureStoreApp(selectedView);
                    }
                }
            }
        };

        $scope.proceedInvoicePayment = function (invoiceView) {
            if (!$scope.ad.loggedUser.company.companyPaymentData || !$scope.ad.loggedUser.company.companyPaymentData.isValid) {
                let msgError = gettextCatalog.getString("Vous devez valider votre compte au préalable");
                $scope.dd.view.invoice.errorMessage = msgError + ".";
                return;
            }
            let question = gettextCatalog.getString("Souhaitez vous procéder au paiement de la facture");
            let opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        var tableModel = [];
                        tableModel["question"] = question + " ?";
                        return tableModel;
                    }
                }
            };

            let d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $scope.dd.view.invoice.loading = true;
                    $scope.dd.view.invoice.errorMessage = null;
                    invoiceView.proceedPayment(function (data) {
                        console.log(data);
                        if ($scope.dd.view.companyView.companyPaymentData.type == "DIRECT_DEBIT") {
                            $window.location.reload(true);
                        } else {

                            if (data && data.resultPayIn && data.resultPayIn.status == "CREATED" && data.resultPayIn.secureModeRedirectURL) {
                                //goto 3D secure URL
                                $window.open(data.resultPayIn.secureModeRedirectURL, "_self");
                            } else {
                                let msgError = gettextCatalog.getString("Validation du paiement refusée. Merci de vérifier vos autorisations de paiement par Internet");
                                $scope.dd.view.invoice.errorMessage = msgError;
                            }
                        }
                        $scope.dd.view.invoice.loading = false;
                    }, function (data) {
                        let msgError = gettextCatalog.getString("Validation du paiement refusée. Merci de vérifier vos autorisations de paiement par Internet");

                        console.log(data);
                        $scope.dd.view.invoice.loading = false;
                        $scope.dd.view.invoice.errorMessage = msgError
                    })
                }
            });


        };

        $scope.updateCompanyWallet = function () {
            if (!$scope.dd.view.companyView.canSaveCompanyLegal() || !$scope.dd.view.wallet.loaded || $scope.dd.view.wallet.walletAmount > 0) {
                return;
            }

            CompanySrv.updateCompanyWallet($scope.dd.view.companyView.getModel(),
                function () {
                    let label = gettextCatalog.getString("La création de votre nouveau porte feuille Mangopay a bien été effectué. L'application a besoin d'être rechargée, cliquer sur 'Oui' pour recharger la page.");

                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/generalConfirmNewLine.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                let tableModel = [];
                                tableModel["description"] = label;
                                return tableModel;
                            }
                        }
                    };

                    let d = $dialog.dialog(opts);
                    d.open().then(function (result) {
                        if (result) {
                            $window.location.reload();
                        }
                    });
                }, function () {
                    let label = gettextCatalog.getString("Impossible de modifier la monnaie associée à votre compte Mangopay.");

                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/errorDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["question"] = label;
                                return tableModel;
                            }
                        }
                    };

                    let d = $dialog.dialog(opts);
                    d.open().then(function () {

                    });
                }
            );
        };

        $scope.getWalletData = function () {
            $scope.dd.view.wallet.loaded = false;
            $scope.dd.view.wallet.payIns = [];
            $scope.dd.view.wallet.payOuts = [];
            CompanySrv.getWalletData($scope.loadWallet);
        };

        $scope.getWalletPayIns = function (pageNext) {
            if ($scope.dd.view.wallet) {
                $scope.dd.view.wallet.loaded = false;
                $scope.dd.view.wallet.payIns = [];
                $scope.dd.view.wallet.payInsPage += pageNext;
                CompanySrv.getWalletPayIns($scope.dd.view.wallet.payInsPage, $scope.loadWallet);
            }
        };

        $scope.loadWallet = function (wallet) {
            if (wallet) {
                $scope.dd.view.wallet.walletAmount = wallet.walletAmount;
                if (wallet.payIns)
                    for (let i = 0; i < wallet.payIns.length; i++) {
                        $scope.dd.view.wallet.payIns.push({
                            id: wallet.payIns[i].id,
                            type: wallet.payIns[i].type,
                            status: wallet.payIns[i].status,
                            nature: wallet.payIns[i].nature,
                            creditedAmount: wallet.payIns[i].creditedAmount,
                            debitedAmount: wallet.payIns[i].debitedAmount,
                            fees: wallet.payIns[i].fees,
                            creationDate: new Date(wallet.payIns[i].creationDate),
                            saleNumber: wallet.payIns[i].saleNumber,
                            advanceNumber: wallet.payIns[i].advanceNumber,
                            canceledSaleNumber: wallet.payIns[i].canceledSaleNumber,
                            customerFullName: wallet.payIns[i].customerFullName,
                            resultMessage: wallet.payIns[i].resultMessage
                        });
                    }
                if (wallet.payOuts) {
                    for (let i = 0; i < wallet.payOuts.length; i++) {
                        $scope.dd.view.wallet.payOuts.push({
                            id: wallet.payOuts[i].id,
                            type: wallet.payOuts[i].type,
                            status: wallet.payOuts[i].status,
                            nature: wallet.payOuts[i].nature,
                            creditedAmount: wallet.payOuts[i].creditedAmount,
                            debitedAmount: wallet.payOuts[i].debitedAmount,
                            creationDate: new Date(wallet.payOuts[i].creationDate)
                        });
                    }
                }
                $scope.dd.view.wallet.loaded = true;
                $scope.dd.view.wallet.currency = wallet.currency;
            }
        };

        $scope.openPayOutDialog = function () {
            //var posView = this;
            if ($scope.dd.view.wallet.walletAmount < 100)
                $scope.dd.view.onlinePayment.payOutAmount = $scope.dd.view.wallet.walletAmount;
            else
                $scope.dd.view.onlinePayment.payOutAmount = 100;
            $scope.dd.view.onlinePayment.payOutAmountInput = $filter('currencyFormatFilter')($scope.dd.view.onlinePayment.payOutAmount);
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/flexyBeauty/dialog/payOutDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        var tableModel = [];
                        tableModel["view"] = $scope.dd.view;
                        return tableModel;
                    }
                }
            };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $scope.dd.view.wallet.loaded = false;
                    CompanySrv.payOut($scope.dd.view.onlinePayment.payOutAmount,
                        function () {
                            //succeed

                            CompanySrv.getWalletData(function (wallet) {
                                $scope.dd.view.onlinePayment.payOutSuccessMessage = true;
                                $scope.dd.view.wallet.loaded = true;
                                $scope.dd.view.wallet.payIns = [];
                                $scope.dd.view.wallet.payOuts = [];
                                $scope.loadWallet(wallet);
                                $scope.dd.view.onlinePayment.tab = 5;
                            });

                        },
                        function (error) {//Failed

                            console.log(error);
                            var label = null;
                            if (error && error.data && error.data.errorCode == "40903")
                                label = gettextCatalog.getString("Votre demande de retrait a été refusée car un retrait est déjà en cours de traitement.");
                            else
                                label = gettextCatalog.getString("Le retrait n'a pas pu être effectué.");
                            var opts = {
                                backdrop: true,
                                keyboard: true,
                                backdropClick: false,
                                templateUrl: '/partials/global/errorDialog.html',
                                controller: 'DialogCtrl',
                                resolve: {
                                    dialogsModel: function () {
                                        var tableModel = [];
                                        tableModel["label"] = label;
                                        return tableModel;
                                    }
                                }
                            };
                            $scope.dd.view.wallet.loaded = true;
                            $dialog.dialog(opts).open();
                        })
                }
            });
        };

        $scope.openLevel3dsDialog = function () {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/flexyBeauty/dialog/level3dsDialog.html',
                controller: 'DialogLevel3DCtrl',
                resolve: {
                    dialogsModel: function () {
                        var tableModel = [];
                        tableModel["companyView"] = $scope.dd.view.companyView;
                        return tableModel;
                    }
                }
            };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $scope.dd.view.companyView.updateModel();
                }
            });
        };

        $scope.onChangeOnlinePaymentTab = function (event, tabIndex) {
            event.stopPropagation();
            $scope.dd.view.onlinePayment.tab = tabIndex;

            if (tabIndex === 3) {
                $scope.onInitCertification();
            }
        };

        $scope.getOnlinePaymentLink = function () {
            let link = null;

            if (Countries.map[$scope.dd.view.companyView.country] && Countries.map[$scope.dd.view.companyView.country].onlinePaymentLink) {
                link = Countries.map[$scope.dd.view.companyView.country].onlinePaymentLink;
            } else {
                link = Countries.map[Countries.FRANCE.countryCode].onlinePaymentLink
            }
            return link;
        };

        $scope.getOnlinePaymentLink = function () {
            let link = null;

            if (Countries.map[$scope.dd.view.companyView.country] && Countries.map[$scope.dd.view.companyView.country].onlinePaymentLink) {
                link = Countries.map[$scope.dd.view.companyView.country].onlinePaymentLink;
            } else {
                link = Countries.map[Countries.FRANCE.countryCode].onlinePaymentLink
            }
            return link;
        };

        $scope.filterSub = function () {
            return function (subscriptionView) {
                if (subscriptionView.storeAppView === undefined) {
                    // prevents eventual subscriptions having a missing store app to be displayed
                    return false;
                }
                let displaySubscription =
                    subscriptionView.storeAppView.isVisibleForCustomers &&
                    subscriptionView.storeAppView.type !== 'discount' &&
                    subscriptionView.isAvailableForBases &&
                    subscriptionView.isRelatedToFilter($scope.dd.view.subscriptions.base);
                const storeAppCodeObject = StoreAppCodeFactory.from(subscriptionView.storeAppView.code);
                if (storeAppCodeObject) {
                    displaySubscription = displaySubscription
                        && storeAppCodeObject.displaySubscription($scope.dd.view.companyView, subscriptionView)
                        && !$scope.hasAnInactiveMandatoryBasedStoreApp(subscriptionView);
                }
                return displaySubscription;
            };
        };

        $scope.hasAnInactiveMandatoryBasedStoreApp = function (subscriptionView) {
            return $scope.dd.view.companyView.subscriptionsView.find(otherSubscriptionView =>
                otherSubscriptionView.storeAppView
                && otherSubscriptionView.storeAppView.code === subscriptionView.storeAppView.mandatoryBases
                && !otherSubscriptionView.isActive);
        };

        $scope.loadSmsReminderSettings = function () {
            if (!$scope.dd.view.smsReminderSettings) {
                $scope.dd.view.isLoadingSmsReminderSettings = true;
                SmsReminderSettingsSrv.get(function (smsReminderSettings) {
                    $scope.dd.view.smsReminderSettings = smsReminderSettings;
                    $scope.updateStoreAppToUsedSmsReminderFirstName();
                    $scope.dd.view.isLoadingSmsReminderSettings = false;
                }, function () {
                    $scope.dd.view.isLoadingSmsReminderSettings = false;
                    $scope.displayErrorDialog();
                });
            }
        };

        $scope.updateStoreAppToUsedSmsReminderFirstName = function () {
            let app = AppData.getAppByCode(AppCode.SMS_APP);
            if (app) {
                let firstNameAppAttribute = app.getAppAttribute(AppCode.SMS_ATTRIBUTE_FIRST_NAME);
                if (firstNameAppAttribute) {
                    $scope.dd.view.cSubscriptionView.storeAppView.smsReminderFirstName = firstNameAppAttribute.value;
                }
            }
        };

        $scope.createSmsReminderSettingsIfNotExist = function () {
            if (!$scope.dd.view.smsReminderSettings || !$scope.dd.view.smsReminderSettings.hourToSend) {
                $scope.dd.view.isLoadingSmsReminderSettings = true;
                SmsReminderSettingsSrv.create(
                    function () {
                        $scope.loadSmsReminderSettings();
                        $scope.dd.view.isLoadingSmsReminderSettings = false;
                    }, function () {
                        $scope.loadSmsReminderSettings();
                        $scope.dd.view.isLoadingSmsReminderSettings = false;
                    });
            }
        };

        $scope.displayErrorDialog = function () {
            let errorMessage = gettextCatalog.getString("Une erreur est survenue. Veuillez réessayer plus tard");

            let opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/errorDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        let tableModel = [];
                        tableModel["label"] = errorMessage;
                        return tableModel;
                    }
                }
            };

            $dialog.dialog(opts).open();
        };

        $scope.onSubscriptionChange = function (subscriptionView) {
            let storeAppCodeObject = StoreAppCodeFactory.from(subscriptionView.storeAppView.code);
            if (subscriptionView.isActive && subscriptionView.storeAppView.code === StoreAppCode.OPTION_SMS_REMINDER_APP_CODE) {
                $scope.loadSmsReminderSettingsAndCreateIfNotExist(subscriptionView);
            }
            storeAppCodeObject.onSubscriptionChange(subscriptionView, $scope.ad.view.companyView, $scope.ad.loggedUser).then(
                (responseOk) => {
                    if (responseOk) {
                        $scope.updateCompanyViewSubscriptionsAndSave(subscriptionView,
                            () => {
                                storeAppCodeObject.afterSubscriptionChange(subscriptionView);
                            },
                            () => {
                                console.warn("Error during disabling of subscription");
                            });
                    } else {
                        subscriptionView.isActive = !subscriptionView.isActive;
                    }
                },
                () => {
                    subscriptionView.isActive = !subscriptionView.isActive;
                }).catch(function () {
                subscriptionView.isActive = !subscriptionView.isActive;
            });
        };

        $scope.updateCompanyViewSubscriptionsAndSave = function (subscriptionView, successFunction, failureFunction) {
            $scope.dd.view.companyView.updateActiveSubscriptions();
            const toUpdateAndSave = $scope.ad.offerManager.computeMandatoryBased($scope.ad.view.companyView, subscriptionView);
            toUpdateAndSave.unshift(subscriptionView);
            toUpdateAndSave.forEach(subscriptionView => subscriptionView.updateModelAndSave(
                function (data) {
                    $scope.loadSubApp(subscriptionView.storeAppView.code);
                    if (successFunction !== undefined) {
                        successFunction(data);
                    }
                },
                function (data) {
                    subscriptionView.isActive = !subscriptionView.isActive;
                    $scope.dd.view.companyView.updateActiveSubscriptions();
                    subscriptionView.updateModel();
                    if (failureFunction !== undefined) {
                        failureFunction(data);
                    }
                }));
        };

        $scope.goToApplication = function () {
            $scope.goToDomain('planningPos');
        };

        $scope.loadSmsReminderSettingsAndCreateIfNotExist = function () {
            if (!$scope.dd.view.smsReminderSettings) {
                $scope.dd.view.isLoadingSmsReminderSettings = true;
                SmsReminderSettingsSrv.get(function (smsReminderSettings) {
                    $scope.dd.view.smsReminderSettings = smsReminderSettings;
                    $scope.updateStoreAppToUsedSmsReminderFirstName();
                    $scope.dd.view.isLoadingSmsReminderSettings = false;
                }, function () {
                    $scope.dd.view.isLoadingSmsReminderSettings = false;
                    $scope.createSmsReminderSettingsIfNotExist();
                });
            }
        };

        $scope.onConfigureStoreApp = function (sView) {
            $scope.dd.view.cAppStorePanel = 1;
            $scope.dd.view.cSubscriptionView = sView;
            if (sView.storeAppView && sView.storeAppView.code === StoreAppCode.OPTION_SMS_REMINDER_APP_CODE) {
                if (sView.isActive) {
                    $scope.dd.view.cSubscriptionView.storeAppView.smsReminderFirstName = true;
                    $scope.loadSmsReminderSettingsAndCreateIfNotExist();
                }
            }
        };

        $scope.saveSmsReminderHour = function (hour) {
            let app = AppData.getAppByCode(AppCode.SMS_APP);
            if (!app) {
                app = new App();
                app.code = AppCode.SMS_APP;
            }

            let lastHour = $scope.dd.view.smsReminderSettings.hourToSend;
            let now = new Date();
            let currentHour = now.getHours();
            let question = "Etes vous sûr de vouloir modifier l'heure d'envoi des rappels de rendez-vous?";
            if (!isNaN(lastHour) && !isNaN(hour)) {
                lastHour = Number(lastHour);
                hour = Number(hour);
            }
            if (lastHour && hour && lastHour > currentHour && currentHour > hour) {
                question = "Attention, l'envoi de rappel de rendez-vous était planifié à " + hour + ". \nEn modifiant l'horaire pour une heure déjà passé, "
                    + "vos SMS ne seront pas envoyés Aujourd'hui. \nEtes vous sûr de vouloir modifier l'heure d'envoi?";
            }
            let opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirmNewLine.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        let tableModel = [];
                        tableModel["question"] = question;
                        return tableModel;
                    }
                }
            };

            let d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    $scope.dd.view.isLoadingSmsReminderSettings = true;
                    let smsReminderSettings = new SmsReminderSettings(hour);
                    SmsReminderSettingsSrv.update(smsReminderSettings, function () {
                        $scope.dd.view.smsReminderSettings.hourToSend = hour;
                        $scope.dd.view.isLoadingSmsReminderSettings = false;
                    }, function () {
                        $scope.dd.view.isLoadingSmsReminderSettings = false;
                        $scope.displayErrorDialog();
                    });
                }
            });
        };

        $scope.saveSmsReminderFirstName = function () {
            let app = AppData.getAppByCode(AppCode.SMS_APP);
            if (!app) {
                app = new App();
                app.code = AppCode.SMS_APP;
            }

            let appAttribute = app.getAppAttribute(AppCode.SMS_ATTRIBUTE_FIRST_NAME);
            if (appAttribute) {
                appAttribute.value = $scope.dd.view.cSubscriptionView.storeAppView.smsReminderFirstName;
            } else {
                let newAppAttribute = new AppAttribute(AppCode.SMS_ATTRIBUTE_FIRST_NAME,
                    $scope.dd.view.cSubscriptionView.storeAppView.smsReminderFirstName, null);
                app.addAppAttribute(newAppAttribute);
            }
            $scope.saveSmsReminderApp(app, "Erreur pendant la modification des rappels de rendez-vous.");
        };

        $scope.saveSmsReminderApp = function (app, errorMessage) {
            AppSrv.save(
                app,
                function (data) {
                },
                function (data) {
                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"] = errorMessage;
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open();
                });
        };

        $scope.checkNotAvailableUpdateBankAccount = function () {
            return !$scope.dd.view.bankAccount.ownerName || $scope.dd.view.bankAccount.ownerName == '' ||
                !$scope.dd.view.bankAccount.ownerAddressLine1 || $scope.dd.view.bankAccount.ownerAddressLine1 == '' ||
                !$scope.dd.view.bankAccount.ownerPostalCode || $scope.dd.view.bankAccount.ownerPostalCode == '' ||
                !$scope.dd.view.bankAccount.ownerCity || $scope.dd.view.bankAccount.ownerCity == '' ||
                !$scope.dd.view.bankAccount.ownerCountry || $scope.dd.view.bankAccount.ownerCountry == '' ||
                (
                    ((!$scope.dd.view.companyView.currency || !$scope.dd.view.companyView.currency.typeBankAccount ||
                            $scope.dd.view.companyView.currency.typeBankAccount == $scope.dd.view.bankAccountTypes.iban) &&
                        !$scope.dd.view.bankAccount.bankAccountDetails.iban || $scope.dd.view.bankAccount.bankAccountDetails.iban == '') ||

                    (($scope.dd.view.companyView.currency && $scope.dd.view.companyView.currency.typeBankAccount &&
                            $scope.dd.view.companyView.currency.typeBankAccount == $scope.dd.view.bankAccountTypes.gb) &&
                        (!$scope.dd.view.bankAccount.bankAccountDetails.accountNumber || $scope.dd.view.bankAccount.bankAccountDetails.accountNumber == '' ||
                            !$scope.dd.view.bankAccount.bankAccountDetails.sortCode || $scope.dd.view.bankAccount.bankAccountDetails.sortCode == ''))
                )
        }

        $scope.updateBankAccount = function () {
            if ($scope.checkNotAvailableUpdateBankAccount()) {
                var msgError = gettextCatalog.getString('Merci de vérifier les champs obligatoires')
                $scope.dd.view.bankAccount.errorMessage = msgError + '.'
                return
            }
            $scope.dd.view.bankAccount.loading = true
            $scope.dd.view.bankAccount.errorMessage = null
            PaymentServiceSrv.updateBankAccount($scope.ad.loggedUser.company,
                $scope.dd.view.bankAccount,
                function () {
                    $scope.dd.view.bankAccount.loading = false
                },
                function () {
                    let msgError = gettextCatalog.getString('Compte bancaire invalide')
                    $scope.dd.view.bankAccount.loading = false
                    $scope.dd.view.bankAccount.errorMessage = msgError
                });
        }

        $scope.setFlowConfigParam = function (kycDocumentType, $flow, fileExtension) {
            if ($flow) {
                $flow.opts.target = 'rest/kyc/document?kycDocumentType=' + kycDocumentType + '&fileExtension=' + fileExtension;
                $flow.opts.headers.Authorization = $scope.ad.currentUser.token;
                if (Auth.isAdmin())
                    $flow.opts.headers.Authorization += '&' + $scope.ad.currentUser.companyCode;
            }

        };

        $scope.manageErrorMessageAndDisableUploadButton = function (file, $flow, message, kycDocumentType) {
            if (!$scope.isValidateExtension(file.getExtension()))
                $scope.dd.view.errors.alertMessage = $scope.dd.view.errors.EXTENSION_ERROR_MESSAGE;

            else if (!$scope.validateFileSize(file, $flow))
                $scope.dd.view.errors.alertMessage = $scope.dd.view.errors.MAX_FILE_SIZE_ERROR_MESSAGE;

            else if (message !== null && message !== "") {
                $scope.dd.view.errors.alertMessage = $scope.dd.view.errors.OTHER_KYC_ERROR_MESSAGE;
                console.log("KYC upload file error: " + message)
            }

            if ($scope.dd.view.errors.alertMessage !== null && $scope.dd.view.errors.alertMessage !== "") {
                $scope.dd.view.displayErrors = true;
            } else {
                $scope.getKycStatus();
                $scope.setUploadDocumentProperty(kycDocumentType);
            }
        };

        $scope.setUploadDocumentProperty = function (kycDocumentType) {
            switch (kycDocumentType) {
                case $scope.dd.view.kycDocumentsType.IDENTITY_PROOF.id:
                    $scope.dd.view.uploadedDocuments.identityProof = true;
                    break;
                case $scope.dd.view.kycDocumentsType.REGISTRATION_PROOF.id:
                    $scope.dd.view.uploadedDocuments.registrationProof = true;
                    break;
                case $scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id:
                    $scope.dd.view.uploadedDocuments.articleOfAssociation = true;
                    break;
            }
        };

        $scope.getUploadDocumentProperty = function (kycDocumentType) {
            let uploadedDocument = false;
            switch (kycDocumentType) {
                case $scope.dd.view.kycDocumentsType.IDENTITY_PROOF.id:
                    uploadedDocument = $scope.dd.view.uploadedDocuments.identityProof;
                    break;
                case $scope.dd.view.kycDocumentsType.REGISTRATION_PROOF.id:
                    uploadedDocument = $scope.dd.view.uploadedDocuments.registrationProof;
                    break;
                case $scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id:
                    uploadedDocument = $scope.dd.view.uploadedDocuments.articleOfAssociation;
                    break;
            }
            return uploadedDocument;
        };

        $scope.getKycDocument = function (type) {
            for (let i = 0; i < $scope.dd.view.kycDocuments.length; i++) {
                let kycDocument = $scope.dd.view.kycDocuments[i];
                if (type === kycDocument.type) {
                    return kycDocument;
                }
            }
            return null;
        };

        $scope.getKycDocumentStatus = function (kycDocumentType) {
            let kycDocument = $scope.getKycDocument(kycDocumentType);
            if (kycDocument)
                return kycDocument.status;
            return null;
        };

        $scope.getKycDocumentRefusedReason = function (kycDocumentType) {
            let kycDocument = $scope.getKycDocument(kycDocumentType);
            if (kycDocument && kycDocument.status === $scope.dd.view.kycDocumentStatus.REFUSED.id) {
                for (let kycRefusedReasonProperty in $scope.dd.view.kycRefusedReason) {
                    let kycRefusedReason = $scope.dd.view.kycRefusedReason[kycRefusedReasonProperty];
                    if (kycDocument.refusedReasonMessage === kycRefusedReason.id) {
                        return kycRefusedReason.label;
                    }
                }
            }
            return "";
        };

        $scope.loadData = function () {
            LoaderKyc.load(
                function () {//success function
                    $scope.dd.view.kycDocuments = KycDocumentData.kycDocuments;
                    $scope.dd.view.numberOfUploadedDocuments = KycDocumentData.kycDocuments.length;

                    if ($scope.dd.view.numberOfUploadedDocuments > 0) {
                        $scope.onTabCertify(3);
                    }

                    $scope.checkValidAllKycDocuments();
                    $scope.getKycStatus();
                    console.log("success");
                },
                function (securityError) {//error function
                    console.log("Fail to load kycDocuments");
                });
        };

        $scope.loadData();

        $scope.validateFileSize = function (file, $flow) {
            return $flow && file.size <= $scope.dd.kycDocumentsConst.MAX_FILE_SIZE;
        };

        $scope.isValidateExtension = function (fileExtension) {
            return $scope.dd.kycDocumentsConst.EXTENSIONS.includes(fileExtension);
        };

        $scope.submitFile = function (file, $flow, kycDocumentType) {
            $scope.setFlowConfigParam(kycDocumentType, $flow, file.getExtension());
            $flow.upload();
            $scope.dd.view.numberOfUploadedDocuments++;
            $scope.dd.view.errors.alertMessage = "";
            $scope.dd.view.displayErrors = false;

            if ($scope.dd.view.numberOfUploadedDocuments >= $scope.getKycDocumentsNumber()) {
                $scope.onTabCertify(3);
            }
        };

        $scope.disableDocumentUpload = function (docType) {
            return ($scope.getKycDocument(docType) &&
                    $scope.getKycDocument(docType).status !== KycDocumentStatus.REFUSED.id) ||
                $scope.getUploadDocumentProperty(docType) &&
                ($scope.dd.view.kycStatus.key === $scope.dd.kycStatusConstants.VALIDATION_ASKED.key ||
                    $scope.dd.view.kycStatus.key === $scope.dd.kycStatusConstants.INCOMPLETE.key);
        };

        $scope.displayWaitingStatusLabel = function (kycDocumentStatus, docType) {
            return kycDocumentStatus === $scope.dd.view.kycDocumentStatus.VALIDATION_ASKED.id ||
                $scope.getUploadDocumentProperty(docType);
        };

        $scope.displayRefusingStatusLabel = function (kycDocumentStatus, docType) {
            return kycDocumentStatus === $scope.dd.view.kycDocumentStatus.REFUSED.id && !$scope.displayWaitingStatusLabel(kycDocumentStatus, docType)
        };

        $scope.displayArticlesOfAssociation = function (type, legalType) {
            return !(type === $scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id && legalType === $scope.dd.kycDocumentsConst.LEGAL_TYPE.SOLETRADER.id);
        };

        $scope.getKycDocumentsNumber = function () {
            let kycDocumentsTypeNumber = Object.keys($scope.dd.view.kycDocumentsType).length;

            if (!$scope.displayArticlesOfAssociation($scope.dd.view.kycDocumentsType.ARTICLES_OF_ASSOCIATION.id, $scope.ad.loggedUser.company.legalType)) {
                kycDocumentsTypeNumber--;
            }

            return kycDocumentsTypeNumber;
        };

        $scope.canDisplayCertificationSteps = function () {
            if ($scope.ad.loggedUser.company.legalType === $scope.dd.kycDocumentsConst.LEGAL_TYPE.SOLETRADER.id) {
                return $scope.dd.view.companyView.companyLegal.legalRepresentativeEmail ? true : false;
            } else {
                return $scope.dd.view.companyView.companyLegal.legalRepresentativeEmail && $scope.dd.view.companyView.companyLegal.companyNumber;
            }
        };
        $scope.canDisplayFreeWording = function () {
            let subscriptionView = $scope.dd.view.cSubscriptionView;
            let canDisplayFree = true;
            if (subscriptionView) {
                if (subscriptionView.storeAppView && subscriptionView.storeAppView.code === StoreAppCode.OPTION_POS_APP_CODE) {
                    let withoutTillStoreAppView = $scope.dd.view.companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE);
                    if (withoutTillStoreAppView && withoutTillStoreAppView.isActive) {
                        canDisplayFree = false;
                    }
                } else if (subscriptionView.price !== 0) {
                    canDisplayFree = false;
                }
            }
            return canDisplayFree;
        };

        $scope.translateHoursToSend = function () {
            let hoursToSend = Constants.SMS_REMINDER_HOURS_TO_SEND;
            for (let i = 0; i < hoursToSend.length; i++) {
                hoursToSend[i].hour = gettextCatalog.getString(hoursToSend[i].hour);
            }

            return hoursToSend;
        };

        $scope.sendIntercomMessage = function (message) {
            Intercom('showNewMessage', message);
        }

        $scope.openBillingManagerPortal = function () {
            $scope.dd.view.invoice.billingManager.creatingPortalSession = true;
            $scope.createBillingManagerPortalSession().then(
                () => {
                    let chargebeeInstance = Chargebee.getInstance();
                    let cbPortal = chargebeeInstance.createChargebeePortal();
                    cbPortal.open({
                        close() {
                        }
                    });
                },
                () => {
                    $scope.dd.view.invoice.billingManager.errorWithPortalSession = true;
                    $scope.dd.view.invoice.billingManager.creatingPortalSession = false;
                }
            );
        }

        $scope.createBillingManagerPortalSession = function () {
            return $scope.initBillingManagerInstanceIfNeeded().then(
                () => {
                    return BillingManagerSrv.createPortalSession().then(
                        data => {
                            let chargebeeInstance = Chargebee.getInstance();
                            if (chargebeeInstance && data.portalSessionAttributes) {
                                $scope.dd.view.invoice.billingManager.errorWithPortalSession = false;
                                chargebeeInstance.setPortalSession(data.portalSessionAttributes);
                            } else {
                                $scope.dd.view.invoice.billingManager.errorWithPortalSession = true;
                            }
                            $scope.dd.view.invoice.billingManager.creatingPortalSession = false;
                        },
                        () => {
                            return Promise.reject();
                        });
                },
                () => {
                    return Promise.reject();
                }
            );
        };

        $scope.initBillingManagerInstanceIfNeeded = function () {
            if (!$scope.dd.view.invoice.billingManager.instanceInitialized) {
                return BillingManagerSrv.computeSiteName().then(
                    data => {
                        Chargebee.init({site: data.siteName});
                        $scope.dd.view.invoice.billingManager.instanceInitialized = true;
                    },
                    () => {
                        return Promise.reject();
                    })
            } else {
                return Promise.resolve();
            }
        };

        $scope.cancellation = function () {
            window.open('https://form.typeform.com/to/zOVaFV2Z#kiuteid=' + $scope.ad.companyCode, '_blank');
        }

        $scope.dd.view.hoursToSend = $scope.translateHoursToSend();
    }
]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/FlexyBeautyCtrl.js